
 <template>
  <div style="border: 1px solid #ccc">
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      class="vue-editor"
      v-model="html"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
      @onChange="editorChange"
      @customPaste="customPaste"
    />
  </div>
</template>


<script>
import "@wangeditor/editor/dist/css/style.css";
import { DomEditor } from "@wangeditor/editor";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
export default {
  name: "VueEditor",
  components: { Editor, Toolbar },
  props: {
    value: {
      type: String,
      default: "",
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请输入内容...",
    },
    maxlength: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      editor: null,
      html: "",
      toolbarConfig: {
        excludeKeys: [
          "code",
          "emotion",
          "group-video",
          "codeBlock",
          "group-image",
        ],
      },
      editorConfig: {
        placeholder: "",
        readOnly: true,
        maxLength: this.maxlength,
      },
      mode: "default", // or 'simple'
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        this.html = val;
      },
    },
    readOnly: {
      deep: true,
      handler(val) {
        this.editorConfig.readOnly = this.readOnly;
      },
    },
    placeholder: {
      deep: true,
      handler(val) {
        this.editorConfig.placeholder = this.placeholder;
      },
    },
  },
  computed: {},
  created() {
    this.editorConfig.readOnly = this.readOnly;
    this.editorConfig.placeholder = this.placeholder;
  },
  mounted() {},
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor);
      //获取工具栏keys
      //  this.$nextTick(() => {
      //   const toolbar = DomEditor.getToolbar(this.editor);
      //   const curToolbarConfig = toolbar.getConfig();
      //   console.log("【 curToolbarConfig 】-39", curToolbarConfig);
      // });
    },
    editorChange(editor) {
      let html = editor.getHtml();
      this.$emit("input", html);
    },
    customPaste(editor, event, callback) {
      // const html = event.clipboardData.getData("text/html"); // 获取粘贴的 html
      const text = event.clipboardData.getData("text/plain"); // 获取粘贴的纯文本
      // const rtf = event.clipboardData.getData('text/rtf') // 获取 rtf 数据（如从 word wsp 复制粘贴）
      // 只粘贴文本
      editor.insertText(text);

      // 返回 false ，阻止默认粘贴行为
      event.preventDefault();
      callback(false);
    },
  },

  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style lang="scss" scoped>
/deep/.w-e-text-placeholder {
  top: 10px;
}
.vue-editor {
  height: 400px;
  /deep/.w-e-max-length-info {
    bottom: 0px;
    right: 1em;
    line-height: 20px;
  }
}
.w-e-full-screen-container {
  z-index: 10;
}
</style>
